import { Filter, ChevronsRight } from 'lucide-react';
import type { TabId, TabState } from '../types';
import { SUB_REGIONS } from '../utils/regions';
import { getFYOptions } from '../utils/filter';
import { useDeals } from '../context/DealsContext';
interface Props {
  tab: TabId;
  state: TabState & {
    status?: string;
  };
  onUpdate: (updates: Partial<TabState>) => void;
}
function getLabel(tab: TabId, s: TabState & {
  status?: string;
}): string {
  let lbl = s.r;
  if (s.sub && s.sub !== 'All') lbl += ' › ' + s.sub;
  if (tab === 'vp' && s.status) lbl += ' · ' + s.status;
  const fyPart = s.fy !== 'All' ? s.fy : '';
  const qPart = s.q !== 'All' ? s.q : '';
  if (fyPart || qPart) lbl += ' · ' + (fyPart && qPart ? fyPart + '-' + qPart : fyPart || qPart);
  return lbl;
}
export function FilterBar({
  tab,
  state,
  onUpdate
}: Props) {
  const {
    deals
  } = useDeals();
  const fyOptions = getFYOptions(deals);
  const quarters = ['All', 'Q1', 'Q2', 'Q3', 'Q4'];
  const statuses = ['All', 'In Progress', 'Closed', 'On Hold'];
  const regions = ['Global', 'AMER', 'EMEA', 'JAPAC'];
  const subRegions = SUB_REGIONS[state.r] ?? [];
  function setRegion(r: string) {
    onUpdate({
      r,
      sub: 'All'
    });
  }
  return <div className="bg-white px-[18px] py-[10px] flex gap-4 flex-wrap items-start border-b border-[#e8eaf0] shadow-[0_1px_3px_rgba(0,0,0,0.04)]" data-id="element-82">
      {/* Region */}
      <div className="flex flex-col gap-[6px]" data-id="element-83">
        <div className="text-[9px] font-bold text-[#8892a0] uppercase tracking-[.06em]" data-id="element-84">Region</div>
        <div className="flex gap-1 flex-wrap" data-id="element-85">
          {regions.map(r => <button key={r} className={`rpill ${state.r === r ? 'active' : ''}`} onClick={() => setRegion(r)} data-id="element-86">
              {r}
            </button>)}
        </div>
        {subRegions.length > 0 && <div className="flex items-center gap-[6px] pt-1 flex-wrap" data-id="element-87">
            <span className="text-[9px] font-semibold text-[#8892a0] uppercase tracking-[.05em] whitespace-nowrap flex items-center gap-1" data-id="element-88">
              <ChevronsRight className="w-[10px] h-[10px] text-[#d0d5dd]" data-id="element-89" />Sub-region
            </span>
            <div className="flex gap-1 flex-wrap" data-id="element-90">
              <button className={`srpill ${state.sub === 'All' ? 'active' : ''}`} onClick={() => onUpdate({
            sub: 'All'
          })} data-id="element-91">
                All {state.r}
              </button>
              {subRegions.map(s => <button key={s} className={`srpill ${state.sub === s ? 'active' : ''}`} onClick={() => onUpdate({
            sub: s
          })} data-id="element-92">
                  {s}
                </button>)}
            </div>
          </div>}
      </div>

      {/* Status (VP only) */}
      {tab === 'vp' && <div className="flex flex-col gap-[6px]" data-id="element-93">
          <div className="text-[9px] font-bold text-[#8892a0] uppercase tracking-[.06em]" data-id="element-94">Status</div>
          <div className="flex gap-1 flex-wrap" data-id="element-95">
            {statuses.map(s => <button key={s} className={`rpill ${(state.status ?? 'All') === s ? 'active' : ''}`} onClick={() => onUpdate({
          status: s
        })} data-id="element-96">
                {s}
              </button>)}
          </div>
        </div>}

      {/* Created Quarter */}
      <div className="flex flex-col gap-[6px]" data-id="element-97">
        <div className="text-[9px] font-bold text-[#8892a0] uppercase tracking-[.06em]" data-id="element-98">Created Quarter</div>
        <div className="flex items-center gap-2 flex-wrap" data-id="element-99">
          <select className="fy-select" value={state.fy} onChange={e => onUpdate({
          fy: e.target.value
        })} data-id="element-100">
            {fyOptions.map(y => <option key={y} value={y} data-id="element-101">{y === 'All' ? 'All FY' : 'FY' + y}</option>)}
          </select>
          <div className="w-px h-[18px] bg-[#e8eaf0] flex-shrink-0" data-id="element-102" />
          {quarters.map(q => <button key={q} className={`cqfpill ${state.q === q ? 'active' : ''}`} onClick={() => onUpdate({
          q
        })} data-id="element-103">
              {q === 'All' ? 'All Q' : q}
            </button>)}
        </div>
      </div>

      {/* Summary label */}
      <div className="text-[10px] text-[#8892a0] ml-auto self-center flex items-center gap-1" data-id="element-104">
        <Filter className="w-[11px] h-[11px]" data-id="element-105" />
        {getLabel(tab, state)}
      </div>
    </div>;
}